import React from 'react';
import { motion } from 'framer-motion';
import { Link2Icon, QrCodeIcon, SmartphoneIcon, UserPlusIcon, CheckIcon } from 'lucide-react';
const webPoints = ["Open the invite link", 'Add a spend or a receipt from the browser', 'See who owes who, settle up and confirm', 'Claim your name if someone added you already'];
const appPoints = ['Every kitty you are part of, plus My Balance', 'Invite from contacts, or by link, code and QR', 'Receipt scan, nudges and push notifications', 'Admin tools for the person running the pot'];
export function WaysToJoin() {
  const scrollToWaitlist = () => {
    document.getElementById('waitlist')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="ways-to-join" className="py-24 lg:py-32 bg-white" data-id="element-295" data-mp="2jk9839erd6iy">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-296" data-mp="2jheofk3kjpql">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="max-w-2xl mb-12 lg:mb-16" data-id="element-297" data-mp="l5fwvmf1hyid">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-kitty-dark tracking-tight mb-4 leading-tight" data-id="element-298" data-mp="1locap6t9d9oa">
            Everyone can join, however they want
          </h2>
          <p className="text-lg text-gray-500" data-id="element-299" data-mp="1bqy19r5r5l5h">
            One person starts the kitty. Everyone else joins from a link in their browser or in the app, and the group is tracking spends within seconds.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-5 gap-6" data-id="element-300" data-mp="24fmvr7cays89">
          {/* Primary: browser join */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5
        }} className="lg:col-span-3 rounded-3xl bg-kitty-yellow-50 border border-kitty-yellow-200 p-8 lg:p-10" data-id="element-301" data-mp="1zefnl768zr12">
            <div className="flex items-center gap-3 mb-6" data-id="element-302" data-mp="37763wb3v7ntv">
              <div className="w-11 h-11 rounded-2xl bg-kitty-yellow flex items-center justify-center" data-id="element-303" data-mp="375v38k5puw6z">
                <Link2Icon className="w-5 h-5 text-kitty-dark" aria-hidden="true" data-id="element-304" data-mp="3b6yhj2848k63" />
              </div>
              <div data-id="element-305" data-mp="2xbw6y1sbq6my">
                <p className="text-xs font-semibold uppercase tracking-widest text-kitty-yellow-700" data-id="element-306" data-mp="3283c3scwbe3u">
                  Fastest way in
                </p>
                <h3 className="text-2xl font-extrabold text-kitty-dark" data-id="element-307" data-mp="2nifasr4psfg4">
                  Join from your browser
                </h3>
              </div>
            </div>

            <ul className="space-y-3 mb-8" data-id="element-308" data-mp="2ekbohslwnen9">
              {webPoints.map(point => <li key={point} className="flex items-start gap-3" data-id="element-309" data-mp="2jhlmhwnd0ymp">
                  <div className="mt-0.5 w-5 h-5 flex-shrink-0 rounded-full bg-kitty-dark flex items-center justify-center" data-id="element-310" data-mp="2jfr00dwfwygi">
                    <CheckIcon className="w-3 h-3 text-kitty-yellow" aria-hidden="true" data-id="element-311" data-mp="29jnz1bdbr5v5" />
                  </div>
                  <span className="text-base text-gray-800 font-medium" data-id="element-312" data-mp="1pxdqg6a6v3yb">
                    {point}
                  </span>
                </li>)}
            </ul>

            <div className="flex flex-wrap items-center gap-4 text-sm font-semibold text-kitty-dark" data-id="element-313" data-mp="1lywv0k04rhwq">
              <span className="inline-flex items-center gap-2" style={{
              alignItems: "center",
              justifyContent: "flex-start"
            }} data-id="element-314" data-mp="1ztyzd2pbwz7f">
                <QrCodeIcon className="w-4 h-4" aria-hidden="true" data-id="element-315" data-mp="28wi09h9k11r1" />
                Link, code or QR
              </span>
              
            </div>
          </motion.div>

          {/* Secondary: the app */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="lg:col-span-2 rounded-3xl bg-gray-950 p-8 lg:p-10 text-white flex flex-col" data-id="element-316" data-mp="2ilro2kxd7y9c">
            <div className="w-11 h-11 rounded-2xl bg-white/[0.08] flex items-center justify-center mb-6" data-id="element-317" data-mp="kzs99uvrm3ta">
              <SmartphoneIcon className="w-5 h-5 text-kitty-yellow" aria-hidden="true" data-id="element-318" data-mp="pxtuomgnyf7x" />
            </div>
            <h3 className="text-2xl font-extrabold mb-2" data-id="element-319" data-mp="uosazm1njdb6">The full app</h3>
            <p className="text-sm text-gray-400 mb-6" data-id="element-320" data-mp="znvgf7ljnljo">
              iOS and Android, currently in closed testing.
            </p>

            <ul className="space-y-3 mb-8" data-id="element-321" data-mp="21g0494ustxp">
              {appPoints.map(point => <li key={point} className="text-sm text-gray-300 leading-relaxed border-l-2 border-kitty-yellow/40 pl-3" data-id="element-322" data-mp="6z7pave461y7">
                  {point}
                </li>)}
            </ul>

            <button onClick={scrollToWaitlist} className="mt-auto w-full bg-kitty-yellow text-kitty-dark py-3.5 rounded-full font-bold transition-colors duration-150 hover:bg-kitty-yellow-500 active:scale-[0.98]" data-id="element-323" data-mp="gxnhz2sshj9t">
              Get on the testing list
            </button>
          </motion.div>
        </div>
      </div>
    </section>;
}